import { PanoramaPreview } from 'shared/components/PanoramaPreview';
import { usePanorama } from './hooks';

import { usePanoramaModal } from './hooks/usePanoramaModal';
import { ModalFullscreen } from '@cian/ui-kit';
import { FullscreenPanoramaContainer } from './containers';

export const PanoramaContainer = () => {
  const panorama = usePanorama();

  const { panoramaOpened, openPanorama, closePanorama } = usePanoramaModal();

  if (!panorama) {
    return null;
  }

  return (
    <>
      <PanoramaPreview onClick={openPanorama} />
      {panoramaOpened && (
        <ModalFullscreen onClose={closePanorama} portal open theme="white">
          <FullscreenPanoramaContainer panorama={panorama} onClose={closePanorama} />
        </ModalFullscreen>
      )}
    </>
  );
};
